// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__aI2R8","productName":"Table_productName__38jKa"};